import { render, staticRenderFns } from "./digital_t_h_info.vue?vue&type=template&id=19ac62a0&scoped=true"
import script from "./digital_t_h_info.vue?vue&type=script&lang=js"
export * from "./digital_t_h_info.vue?vue&type=script&lang=js"
import style0 from "./digital_t_h_info.vue?vue&type=style&index=0&id=19ac62a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ac62a0",
  null
  
)

export default component.exports